import { PropTypes } from 'react'
import React from 'react'
import ReactPaginate from 'react-paginate'
import Config from '../config'

class ResourceList extends React.Component{
	render(){
		let itemViews;

		if(this.props.hasLoaded){
			if(this.props.items.length > 0){
				itemViews = this.props.items.map(item => React.createElement(this.props.itemView, item));
			} else if(!this.props.isLoading) {
				itemViews = <div className="no-results"><div className="content">{ Config.noResultsText }</div></div>;
			}
		} else {
			itemViews = <div className="post-content" dangerouslySetInnerHTML={{__html: this.props.staticHtml}} />;
		}

		let afterListing = null;
		if(this.props.isLoading){
			afterListing = <div className="loading-throbber"><span className="text">Loading...</span><div className="cssload-ball" /></div>
		} else if(this.props.totalPages > 1){
			afterListing = <ReactPaginate previousLabel={<i className="icon icon-arrow-down" data-grunticon-embed />}
				                     nextLabel={<i className="icon icon-arrow-down" data-grunticon-embed />}
				                     breakLabel={'…'}
				                     breakClassName={"break-me"}
				                     forcePage={this.props.page - 1}
				                     pageCount={this.props.totalPages}
				                     marginPagesDisplayed={1}
				                     pageRangeDisplayed={3}
				                     onPageChange={this.props.onClickPage}
				                     containerClassName={"pagination"}
				                     subContainerClassName={"pages pagination"}
									 hrefBuilder={(page, pageCount) =>
										page >= 1 && page <= pageCount ? `?pages=${page}&text=${this.props.filter.text}` : '#'
									  }
				                     activeClassName={"active"} />;
		}

		return (
			<div className="blog-posts">
				<div className="container">
					{ itemViews }
					{ afterListing }
				</div>
			</div>
		)
	}

	componentDidUpdate(){
		let $ = window.jQuery;
		let blogPost = $('.blog-posts');
		let postGrid = blogPost.find('.grid-item');
	    let blogPostShare = postGrid.find('.social-share');
	    blogPostShare.hover(function() {
	        $(this).toggleClass('slide-share');
	    });
		if(window.grunticon){
			window.grunticon.embedSVG()
		}

		blogPost.find('.blog-ebook-cta').remove();
		blogPost.find('.grid-item:eq(1)').after(Config.ebookContent);
	}
	componentDidMount() {
		let $ = window.jQuery;
		let blogPost = $('.blog-posts');
		blogPost.find('.blog-ebook-cta').remove();
		blogPost.find('.grid-item:eq(1)').after(Config.ebookContent);
		if(window.grunticon){
			window.grunticon.embedSVG()
		}
	}
}

ResourceList.propTypes = {
	items: PropTypes.array,
	itemView: PropTypes.func,
	isLoading: PropTypes.bool,
	hasLoaded: PropTypes.bool,
	staticHtml: PropTypes.string,
	page: PropTypes.number,
	totalPages: PropTypes.number,
	onClickPage: PropTypes.func,
	filter: PropTypes.array
}

export default ResourceList;
